import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import Image from 'next/image';
import { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isSideways, ROTATION_CLASS_NAME, type Rotation } from '@/utils/rotation';
type BaseImageProps = {
  alt: string;
  src: string;
  rotation?: Rotation;
};
const BaseImage = forwardRef<HTMLImageElement, BaseImageProps>((t0, ref) => {
  const $ = _c(30);
  const {
    alt,
    src,
    rotation: t1
  } = t0;
  const rotation = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "fieldset.documents.details"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const [hasError, setHasError] = useState(false);
  const [aspectRatio, setAspectRatio] = useState(null);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = event => {
      const {
        naturalWidth,
        naturalHeight
      } = event.currentTarget;
      if (naturalWidth > 0 && naturalHeight > 0) {
        setAspectRatio(naturalWidth / naturalHeight);
      }
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleLoad = t3;
  if (hasError) {
    let t4;
    if ($[2] !== alt || $[3] !== t) {
      t4 = t(_temp, {
        alt
      });
      $[2] = alt;
      $[3] = t;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    let t5;
    if ($[5] !== t4) {
      t5 = <div className="p-3 w-full border rounded-md border-tertiary flex items-center justify-center"><p className="max-w-[700px] text-body-2 text-tertiary text-center">{t4}</p></div>;
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  const t4 = rotation === 180;
  let t5;
  if ($[7] !== t4) {
    t5 = cx("object-contain w-full h-auto max-w-full", {
      "rotate-180": t4
    });
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setHasError(true);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== alt || $[11] !== ref || $[12] !== src || $[13] !== t5) {
    t7 = <Image src={src} width={0} height={0} alt={alt} className={t5} ref={ref} data-dd-privacy="mask" onError={t6} onLoad={handleLoad} />;
    $[10] = alt;
    $[11] = ref;
    $[12] = src;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const image = t7;
  if (isSideways(rotation) && aspectRatio !== null) {
    const t8 = 1 / aspectRatio;
    let t9;
    if ($[15] !== t8) {
      t9 = {
        aspectRatio: t8
      };
      $[15] = t8;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    const t10 = ROTATION_CLASS_NAME[rotation];
    let t11;
    if ($[17] !== t10) {
      t11 = cx("absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2", t10);
      $[17] = t10;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    const t12 = `${aspectRatio * 100}%`;
    let t13;
    if ($[19] !== t12) {
      t13 = {
        width: t12
      };
      $[19] = t12;
      $[20] = t13;
    } else {
      t13 = $[20];
    }
    let t14;
    if ($[21] !== image || $[22] !== t11 || $[23] !== t13) {
      t14 = <div className={t11} style={t13}>{image}</div>;
      $[21] = image;
      $[22] = t11;
      $[23] = t13;
      $[24] = t14;
    } else {
      t14 = $[24];
    }
    let t15;
    if ($[25] !== t14 || $[26] !== t9) {
      t15 = <div className="relative w-full overflow-hidden border rounded shadow-md bg-primary border-tertiary" style={t9}>{t14}</div>;
      $[25] = t14;
      $[26] = t9;
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    return t15;
  }
  let t8;
  if ($[28] !== image) {
    t8 = <div className="overflow-hidden border rounded shadow-md bg-primary border-tertiary">{image}</div>;
    $[28] = image;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  return t8;
});
export default BaseImage;
function _temp($) {
  return $.failedToLoad;
}